import i18n from "i18next";

i18n.init({
	resources: {
		en: {
			translation: require("./shared/locales/en.json"),
		},
		ru: {
			translation: require("./shared/locales/ru.json"),
		},
	},
	lng: "en",
	fallbackLng: "en",
});

export default i18n;
